import { createRouter, createWebHashHistory } from 'vue-router'
import Hall from '@/views/Hall.vue'
import Detail from '@/views/Detail'
import Jcdetail from '@/views/Jcdetail'
import History from '@/views/History'

const routes = [
  {
    path: '/',
    name: 'Hall',
    component: Hall
  },
  {
    path: '/detail/:lotid/:issue',
    name: 'Detail',
    component: Detail
  },
  {
    path: '/jcdetail/:lotid/:issue',
    name: 'Jcdetail',
    component: Jcdetail
  },
  {
    path: '/history/:lotid',
    name: 'History',
    component: History
  },
  
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('../views/About.vue')
  // }
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
